import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const NoAccess = () => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "background.default",
                px: 3,
                textAlign: "center",
            }}
        >
            <Typography variant="h5" color="text.primary">
                🚫 {t("noAccess.message")}
            </Typography>
        </Box>
    );
};

export default NoAccess;